//横琴马拉松 full
import PlatfromMarathonHengqinFull from '@containers/platfrom_marathon/marathon_HengqinMara'

export default {
  PlatfromMarathonHengqinFull,
}
